import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <>
    <path
      d="M8.57788 17.967C8.84888 17.967 9.07788 18.196 9.07788 18.467V18.498C9.07788 18.769 8.84888 18.998 8.57788 18.998H4.57788C4.30688 18.998 4.07788 18.769 4.07788 18.498V18.467C4.07788 18.196 4.30688 17.967 4.57788 17.967H8.57788V17.967ZM8.57788 16.967H4.57788C3.75288 16.967 3.07788 17.642 3.07788 18.467V18.498C3.07788 19.323 3.75288 19.998 4.57788 19.998H8.57788C9.40288 19.998 10.0779 19.323 10.0779 18.498V18.467C10.0779 17.642 9.40288 16.967 8.57788 16.967V16.967Z"
      fill="currentColor"
    />
    <path
      d="M9.98388 7.00806V12.6131L9.25988 13.4111L9.00388 13.6921L8.99988 14.0721L8.98388 16.4821C8.98388 16.7531 8.75488 16.9821 8.48388 16.9821H4.57788C4.35288 16.9821 4.15588 16.8241 4.09688 16.6141L6.99988 7.89606C7.21988 7.37306 7.63088 7.00806 7.99988 7.00806H9.98388V7.00806ZM10.9839 6.00806H7.99988C7.17488 6.00806 6.43788 6.65406 6.07788 7.50806L3.07788 16.4831C3.07788 17.3081 3.75288 17.9831 4.57788 17.9831H8.48388C9.30888 17.9831 9.98388 17.3081 9.98388 16.4831L9.99988 14.0831L10.9839 13.0001V6.00806Z"
      fill="currentColor"
    />
    <path d="M13 8.00195V10.023H11V8.00195H13ZM14 7.00195H10V11.023H14V7.00195Z" fill="currentColor" />
    <path
      d="M9.98401 5.00195V6.00195H8.03101V5.00195H9.98401ZM10.139 4.00195H7.87701C7.41001 4.00195 7.03101 4.38095 7.03101 4.84795V6.15695C7.03101 6.62395 7.41001 7.00295 7.87701 7.00295H10.139C10.606 7.00295 10.985 6.62395 10.985 6.15695V4.84695C10.984 4.37995 10.606 4.00195 10.139 4.00195Z"
      fill="currentColor"
    />
    <path
      d="M19.406 17.946C19.677 17.946 19.906 18.175 19.906 18.446V18.477C19.906 18.748 19.677 18.977 19.406 18.977H15.406C15.135 18.977 14.906 18.748 14.906 18.477V18.446C14.906 18.175 15.135 17.946 15.406 17.946H19.406V17.946ZM19.406 16.946H15.406C14.581 16.946 13.906 17.621 13.906 18.446V18.477C13.906 19.302 14.581 19.977 15.406 19.977H19.406C20.231 19.977 20.906 19.302 20.906 18.477V18.446C20.906 17.621 20.231 16.946 19.406 16.946V16.946Z"
      fill="currentColor"
    />
    <path
      d="M15.984 6.98706C16.353 6.98706 16.764 7.35206 16.97 7.83906L19.888 16.5941C19.828 16.8031 19.632 16.9621 19.407 16.9621H15.5C15.229 16.9621 15 16.7331 15 16.4511L14.984 14.0521L14.98 13.6721L14.724 13.3911L14 12.5931V6.98706H15.984V6.98706ZM15.984 5.98706H13V12.9801L13.984 14.0631L14 16.4621C14 17.2871 14.675 17.9621 15.5 17.9621H19.406C20.231 17.9621 20.906 17.2871 20.906 16.4621L17.906 7.48706C17.547 6.63406 16.809 5.98706 15.984 5.98706V5.98706Z"
      fill="currentColor"
    />
    <path
      d="M15.953 4.98096V5.98096H14V4.98096H15.953ZM16.108 3.98096H13.846C13.379 3.98096 13 4.35996 13 4.82696V6.13596C13 6.60296 13.379 6.98196 13.846 6.98196H16.108C16.575 6.98196 16.954 6.60296 16.954 6.13596V4.82696C16.953 4.35996 16.575 3.98096 16.108 3.98096V3.98096Z"
      fill="currentColor"
    />
  </>
);

const Icon = createSvgIcon(svg, 'Binoculars');

export default Icon;
